import styled from '@emotion/styled';
import {
  palette,
  spacing,
  typography,
} from '../../style-utils/theme';

/**
 * Styled parts for <ScreenHeader />.
 *
 * These shapes are MOVED VERBATIM from the shift surfaces (shifts.styled.tsx:
 * PageHeaderRow, PageTitle, PageSub, Actions, QuietAction) so the shared
 * header is pixel-identical to the header /shift-monitor already ships.
 * That is the whole point: pages migrated onto ScreenHeader later must not
 * change appearance in the process. Do not "improve" the values here without
 * re-checking /shift-monitor and /iq-handover, which still use the originals.
 *
 * No aurora: gradient.aurora is reserved for Lobbero IQ (design_system.md).
 * A back button is not AI.
 */

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.sm};
  flex-wrap: wrap;
`;

export const HeaderTitle = styled.h1`
  font-family: ${typography.display};
  font-size: ${typography.size.xl}px;
  font-weight: ${typography.weight.bold};
  letter-spacing: ${typography.tracking.snug};
  color: ${palette.ink};
  margin: 0;
`;

export const HeaderSub = styled.p`
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  color: ${palette.slate};
  margin: ${spacing.half} 0 0;
`;

/* shifts.styled.tsx Actions, verbatim — the row that holds the page's own
   actions plus the back button, so the spacing matches /shift-monitor. */
export const HeaderActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing.xs};
`;

/**
 * `BackAction` HAS MOVED and is now an alias, kept so nothing that imported it
 * breaks. The real button is <BackButton> in ./back-button — one design, one
 * position, one component (the unification pass, 2026-08-11).
 *
 * It is NOT re-declared here. A second styled button that merely looks the same
 * is how the product ended up with five back buttons in the first place: they
 * were all "the same as the other one" on the day they were written.
 */
export { BackButtonBase as BackAction } from './back-button';
